import Topbar from './Root';
import Portal from './Portal';

Portal.Root = Topbar;

export default Portal;
